import React, { useState } from "react";
import "./Faq.css";
import { FaPlus, FaMinus } from "react-icons/fa";

    const  faqsData = [
  {
    question: "What are the advantages of aluminium windows and doors?",
    answer: "Aluminium windows and doors are strong, rust-proof, lightweight, and long-lasting. They offer modern style, durability, and low maintenance."
  },
  {
    question: "Can I customize the size and design?",
    answer: "Yes, all aluminium windows and doors can be customized in size, style, colour, and finish, including sliding, casement, and openable designs."
  },
  {
    question: "Do aluminium windows and doors require maintenance?",
    answer: "Very little. A simple cleaning and occasional lubrication of moving parts are enough to keep them working smoothly for years."
  },
  {
    question: "Are aluminium windows and doors safe?",
    answer: "Yes, aluminium frames are strong and support high-quality locks and toughened glass, making them highly secure for homes and offices."
  },
  {
    question: "Do you provide installation and after-service?",
    answer: "Yes, we handle measurement, fabrication, installation, and after-service support to ensure long-term performance and customer satisfaction."
  }
];


const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h2 className="faq-title">FAQs</h2>
      {faqsData.map((faq, index) => (
        <div
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
          key={index}
          onClick={() => toggleFaq(index)}
        >
          <div className="faq-question">
            <span>{faq.question}</span>
            <span className="faq-icon">
              {activeIndex === index ? <FaMinus /> : <FaPlus />}
            </span>
          </div>
          <div className="faq-answer">
            <p>{faq.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
